import { render, staticRenderFns } from "./checklist-task-list.vue?vue&type=template&id=39f39e71&scoped=true"
import script from "./checklist-task-list.vue?vue&type=script&lang=js"
export * from "./checklist-task-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f39e71",
  null
  
)

export default component.exports